export default [
  {
    path: "/editorialReview",
    component: (resolve) => require(["@/views/home"], resolve),
    children: [
      {
        path: "/editorialReview/shouye",
        name: "首页",
        // redirect:'/editorialReview/shouye',
        meta: {
          title: "首页",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/shouye/index"], resolve),
      },
      {
        path: "/editorialReview/initialAllocation",
        name: "初审分配 ",
        meta: {
          title: "初审分配",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/initialAllocation/index"], resolve),
      },
      {
        path: "/editorialReview/screeningAllocation",
        name: "筛稿分配",
        meta: {
          title: "筛稿分配",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/screeningAllocation/index"], resolve),
      },
      {
        path: "/editorialReview/initialManuscript",
        name: "稿件初审",
        meta: {
          title: "稿件初审",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/initialManuscript/index"], resolve),
      },
      {
        path: "/editorialReview/reviewTheAllocation",
        name: "复审分配",
        meta: {
          title: "复审分配",
        },
        component: (resolve) =>
          require([
            "@/views/editorialReview/reviewTheAllocation/index",
          ], resolve),
      },
      {
        path: "/editorialReview/finalAllocation",
        name: "终审分配",
        meta: {
          title: "终审分配",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/finalAllocation/index"], resolve),
      },
      {
        path: "/editorialReview/externalDistribution",
        name: "外审分配",
        meta: {
          title: "外审分配",
        },
        component: (resolve) =>
          require([
            "@/views/editorialReview/externalDistribution/index",
          ], resolve),
      },
      {
        path: "/editorialReview/employedToConfirm",
        name: "录用确认",
        meta: {
          title: "录用确认",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/employedToConfirm/index"], resolve),
      },
      {
        path: "/editorialReview/manuscriptScheduling",
        name: "稿件排期",
        meta: {
          title: "稿件排期",
        },
        component: (resolve) =>
          require([
            "@/views/editorialReview/manuscriptScheduling/index",
          ], resolve),
      },
      // 刊期发排，排版和校对三个页面合为一个页面
      {
        path: "/editorialReview/postingDateFaPai",
        name: "发排/排版/校对",
        meta: {
          title: "发排/排版/校对",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/postingDateFaPai/index"], resolve),
      },
      // {
      //   path: "/editorialReview/setTyp",
      //   name: "刊期排版",
      //   meta: {
      //     title: "刊期排版",
      //   },
      //   component: (resolve) =>
      //     require(["@/views/editorialReview/setTyp/index"], resolve),
      // },
      // {
      //   path: "/editorialReview/schoolTeam",
      //   name: "刊期校对",
      //   meta: {
      //     title: "刊期校对",
      //   },
      //   component: (resolve) =>
      //     require(["@/views/editorialReview/schoolTeam/index"], resolve),
      // },
      {
        path: "/editorialReview/outSlice",
        name: "出片/改片",
        meta: {
          title: "出片/改片",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/outSlice/index"], resolve),
      },

      {
        path: "/editorialReview/readChange",
        name: "审读/改红",
        meta: {
          title: "审读/改红",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/readChange/index"], resolve),
      },
     
      // 改片和印刷之间增加校样节点
      {
        path: "/editorialReview/periodicalProof",
        name: "确认校样",
        meta: {
          title: "确认校样",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/periodicalProof/index"], resolve),
      },

      {
        path: "/editorialReview/printing",
        name: "印刷",
        meta: {
          title: "印刷",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/printing/index"], resolve),
      },
      {
        path: "/editorialReview/distributionMailing",
        name: "发行邮寄",
        meta: {
          title: "发行邮寄",
        },
        component: (resolve) =>
          require([
            "@/views/editorialReview/distributionMailing/index",
          ], resolve),
      },
      {
        path: "/editorialReview/finalVersionOfTheFile",
        name: "终版存档",
        meta: {
          title: "终版存档",
        },
        component: (resolve) =>
          require([
            "@/views/editorialReview/finalVersionOfTheFile/index",
          ], resolve),
      },
      {
        path: "/editorialReview/baseData",
        name: "基本资料",
        meta: {
          title: "基本资料",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/baseData/index"], resolve),
      },
      {
        path: "/editorialReview/notify",
        name: "消息通知",
        meta: {
          title: "消息通知",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/notify/index"], resolve),
      },
      {
        path: "externalDistribution",
        name: "外审分配",
        meta: {
          title: "外审分配",
        },
        component: (resolve) =>
          require([
            "@/views/editorialReview/externalDistribution/index",
          ], resolve),
      },
      {
        path: "onlineEdit",
        name: "修改稿件信息",
        meta: {
          title: "修改稿件信息",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/online/onlineEdit/index"], resolve),
      },
      {
        path: "/editorialReview/online",
        name: "",
        meta: {
          title: "",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/online/index"], resolve),
      },
      {
        path: "/editorialReview/check",
        name: "查看",
        meta: {
          title: "查看",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/online/check"], resolve),
      },
       // v3.0.4 增加附件审核
       {
        path: "/editorialReview/attachmentReview",
        name: "附件审核",
        meta: {
          title: "附件审核",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/attachmentReview/index"], resolve),
      },
      {
        path: "/editorialReview/batchRecording",
        name: "批量记录",
        meta: {
          title: "批量记录",
        },
        component: (resolve) =>
          require(["@/views/editorialReview/batchRecording/index"], resolve),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/editorialReview_routers.js